// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__3_neL","disabled":"Button_disabled__1igO3","danger":"Button_danger__3FRfc"};